import type { Product } from '../types/catalog';
import { images } from './images';

export const products: Product[] = [
  {
    id: 'boucles-arche-terracotta',
    name: 'Boucles Arche terracotta',
    creatorId: 'maison-ocre',
    category: 'bijoux',
    price: 38,
    images: [images.earrings, images.catBijoux],
    description:
      'Une arche de laiton martelé à la main, prolongée d’une pastille d’argile terracotta cuite à l’atelier. Légères, elles se portent du matin au soir.',
    details: ['Laiton brut martelé, crochets en laiton doré', 'Argile cuite et vernie mate', 'Hauteur : 4,5 cm · 6 g la paire', 'Éviter le contact avec l’eau et les parfums'],
    stock: 6,
    addedAt: '2026-08-01',
  },
  {
    id: 'collier-rive',
    name: 'Collier Rive, perles d’eau douce',
    creatorId: 'perle-de-rive',
    category: 'bijoux',
    price: 64,
    images: [images.necklace, images.catBijoux],
    description:
      'Des perles baroques enfilées une à une sur fil de soie, et une petite médaille martelée en plaqué or. Aucun collier n’est tout à fait identique.',
    details: ['Perles d’eau douce baroques', 'Médaille et fermoir plaqué or 3 microns', 'Longueur : 42 cm + 4 cm de chaînette', 'Livré dans une pochette en lin'],
    stock: 3,
    addedAt: '2026-09-01',
  },
  {
    id: 'bague-pierre-brute',
    name: 'Bague Pierre brute, argent 925',
    creatorId: 'argent-brut',
    category: 'bijoux',
    price: 72,
    images: [images.ring, images.catBijoux],
    description:
      'Un anneau d’argent recyclé coulé à l’atelier, serti d’une petite pierre verte laissée brute. La pierre varie légèrement d’une bague à l’autre.',
    details: ['Argent 925 recyclé', 'Prehnite brute, environ 6 mm', 'Largeur de l’anneau : 2 mm', 'Mise à taille gratuite en boutique'],
    stock: 4,
    options: { label: 'Taille', values: ['50', '52', '54', '56', '58'] },
    addedAt: '2026-09-20',
  },
  {
    id: 'parure-laiton-martele',
    name: 'Parure laiton martelé',
    creatorId: 'maison-ocre',
    category: 'bijoux',
    price: 85,
    images: [images.catBijoux, images.earrings],
    description:
      'La parure complète de Maison Ocre : boucles, collier et bague assortis, présentés dans un écrin en carton recyclé. Un seul exemplaire réalisé pour la boutique.',
    details: ['Laiton martelé et argile cuite', 'Collier 45 cm, boucles 3 cm', 'Bague ajustable', 'Pièce unique'],
    stock: 1,
    addedAt: '2026-08-01',
  },
  {
    id: 'cabas-lin-cognac',
    name: 'Cabas en lin, anses cognac',
    creatorId: 'lin-et-lame',
    category: 'mode',
    price: 79,
    images: [images.bag, images.catTextile],
    description:
      'Un grand cabas en lin lavé, doublé, avec des anses en cuir tanné végétal cousues main. Une poche intérieure zippée garde l’essentiel à portée.',
    details: ['Lin lavé 100 % européen', 'Anses en cuir tanné végétal', '40 × 38 × 12 cm', 'Lavage à 30 °C sans les anses'],
    stock: 5,
    addedAt: '2026-07-20',
  },
  {
    id: 'chapeau-feutre-rouille',
    name: 'Chapeau feutre Rouille',
    creatorId: 'feutre-et-forme',
    category: 'mode',
    price: 115,
    images: [images.hat, images.catTextile],
    description:
      'Feutre de laine mis en forme à la vapeur sur une forme en bois ancienne, ruban de cuir fin. Un bord légèrement relevé, une couronne souple.',
    details: ['Feutre 100 % laine', 'Ruban en cuir végétal', 'Bord : 7 cm', 'Ajustement offert en boutique'],
    stock: 4,
    options: { label: 'Tour de tête', values: ['55 cm', '57 cm', '59 cm'] },
    addedAt: '2026-09-10',
  },
  {
    id: 'porte-cartes-cuir',
    name: 'Porte-cartes cuir végétal',
    creatorId: 'cuir-sauvage',
    category: 'mode',
    price: 45,
    images: [images.wallet, images.catTextile],
    description:
      'Quatre poches et un compartiment central, coupé dans un cuir tanné végétal et cousu au point sellier. Il fonce et se patine avec le temps.',
    details: ['Cuir de vachette tanné végétal, 1,2 mm', 'Couture au point sellier, fil de lin ciré', '10,5 × 7,5 cm', 'Tranches teintées et lustrées à la main'],
    stock: 8,
    addedAt: '2026-07-25',
  },
  {
    id: 'chemise-lin-garance',
    name: 'Chemise en lin teinte à la garance',
    creatorId: 'fil-indigo',
    category: 'mode',
    price: 128,
    images: [images.catTextile, images.hat],
    description:
      'Une chemise ample en lin épais, teinte à la racine de garance. Col officier, boutons en corozo. La couleur s’adoucit doucement au fil des lavages.',
    details: ['Lin 100 %, 185 g/m²', 'Teinture végétale à la garance', 'Coupe ample, mixte', 'Lavage à froid, séchage à plat'],
    stock: 3,
    options: { label: 'Taille', values: ['S', 'M', 'L'] },
    addedAt: '2026-10-01',
  },
  {
    id: 'vase-dune',
    name: 'Vase Dune, grès émaillé sable',
    creatorId: 'atelier-sillon',
    category: 'deco',
    price: 68,
    images: [images.vase, images.catDeco],
    description:
      'Tourné puis légèrement déformé à la main, ce vase en grès moucheté est recouvert d’un émail mat couleur sable. Étanche, pour fleurs fraîches ou séchées.',
    details: ['Grès chamotté cuit à 1280 °C', 'Émail mat sans plomb', 'Hauteur : 22 cm', 'Signé sous la base'],
    stock: 2,
    addedAt: '2026-09-15',
  },
  {
    id: 'mug-sillon',
    name: 'Mug Sillon',
    creatorId: 'atelier-sillon',
    category: 'deco',
    price: 32,
    images: [images.mugs, images.catDeco],
    description:
      'Un mug généreux à l’anse confortable, pour le café du matin ou le thé de l’après-midi. Deux émaux au choix, tous deux préparés à l’atelier.',
    details: ['Grès, contenance 30 cl', 'Compatible lave-vaisselle et micro-ondes', 'Vendu à l’unité', 'Légères variations d’émail'],
    stock: 10,
    options: { label: 'Émail', values: ['Sauge', 'Terracotta coulure'] },
    addedAt: '2026-09-15',
  },
  {
    id: 'bol-noyer',
    name: 'Bol tourné en noyer',
    creatorId: 'bois-de-coeur',
    category: 'deco',
    price: 56,
    images: [images.bowl, images.catDeco],
    description:
      'Tourné dans un noyer tombé lors d’une tempête dans le Jura. Fini à l’huile alimentaire, il accueille fruits, pain ou clés de la maison.',
    details: ['Noyer massif local', 'Finition huile de lin alimentaire', 'Ø 20 cm · hauteur 8 cm', 'Pièce unique'],
    stock: 1,
    addedAt: '2026-08-15',
  },
  {
    id: 'lampe-lune',
    name: 'Lampe Lune, céramique et lin',
    creatorId: 'terre-de-lune',
    category: 'deco',
    price: 145,
    images: [images.lamp, images.catDeco],
    description:
      'Un pied en faïence émaillée blanc mat et un abat-jour plissé en lin naturel cousu main. Une lumière douce et diffuse, idéale en lampe de chevet.',
    details: ['Faïence émaillée, abat-jour lin', 'Hauteur : 38 cm', 'Câble textile 1,8 m, interrupteur', 'Ampoule E14 non fournie'],
    stock: 2,
    addedAt: '2026-08-20',
  },
  {
    id: 'herbier-sauvage',
    name: 'Herbier sauvage, tirage encadré',
    creatorId: 'herbier-noir',
    category: 'deco',
    price: 58,
    images: [images.print, images.catDeco],
    description:
      'Tirage d’art d’une planche dessinée à l’encre et à l’aquarelle, représentant les herbes des dunes. Numéroté et signé, livré encadré en chêne clair.',
    details: ['Tirage pigmentaire sur papier coton 310 g', 'Format 30 × 40 cm, cadre chêne', 'Édition limitée à 30 exemplaires', 'Certificat signé'],
    stock: 7,
    addedAt: '2026-09-05',
  },
  {
    id: 'bougie-feu-de-bois',
    name: 'Bougie Feu de bois',
    creatorId: 'cire-et-flamme',
    category: 'deco',
    price: 34,
    images: [images.candle, images.catDeco],
    description:
      'Cire de soja et de colza coulée dans un pot en céramique réutilisable. Notes de cèdre, de bois fumé et une pointe de vanille.',
    details: ['Cire végétale française', 'Environ 40 heures de combustion', 'Pot en céramique tourné main', 'Mèche en coton'],
    stock: 9,
    addedAt: '2026-08-10',
  },
  {
    id: 'trio-savons',
    name: 'Trio de savons à froid',
    creatorId: 'savonnerie-des-pres',
    category: 'local',
    price: 18,
    images: [images.soap, images.catLocal],
    description:
      'Trois savons surgras : avoine douce, argile rose et sauge-thym. Saponifiés à froid et séchés six semaines, pour le visage comme pour le corps.',
    details: ['3 × 100 g', 'Huiles bio, 8 % de surgras', 'Sans parfum de synthèse', 'Emballage papier kraft'],
    stock: 20,
    addedAt: '2026-09-01',
  },
  {
    id: 'miel-fleurs-sauvages',
    name: 'Miel de fleurs sauvages',
    creatorId: 'rucher-du-vallon',
    category: 'local',
    price: 12,
    images: [images.honey, images.catLocal],
    description:
      'Récolté à la fin de l’été entre vignes et prairies, ce miel crémeux a des notes florales et légèrement boisées. Extrait à froid.',
    details: ['Pot de 500 g', 'Récolte 2026, Entre-deux-Mers', 'Non pasteurisé', 'À conserver à l’abri de la lumière'],
    stock: 15,
    addedAt: '2026-10-01',
  },
  {
    id: 'coffret-gourmand',
    name: 'Coffret gourmand de saison',
    creatorId: 'la-fabrique-sucree',
    category: 'local',
    price: 42,
    images: [images.catLocal, images.honey],
    description:
      'Une confiture de figues, une gelée de coings, des sablés au beurre salé et un petit pot de miel du Rucher du Vallon, dans une boîte à garder.',
    details: ['Confiture 220 g, gelée 220 g', 'Sablés 120 g, miel 125 g', 'Fruits des vergers du Lot-et-Garonne', 'Idéal à offrir'],
    stock: 6,
    addedAt: '2026-10-01',
  },
];
